export const environment = {

    production: false,
  
    isDev: true,
  
   
  
    apiEndPoint:
  
      "https://ai-retail-genai-kdp-api.azurewebsites.net/docs#/GenAI%20APIs/chat_copilot_get",
  
   
  
    default_app_route: "/home",
  
  };
  
   
